import { styled } from "@mui/material";


const StyledChatItem = styled('article')`
  padding: 16px 10px;



  .chat-item {
    &__inner {
      display: flex;
      gap: 12px;

    }

    &__img-wrapper {
      flex-shrink: 0;
      width: 90px;
      height: 90px;
      border-radius: 10px;
      overflow: hidden;
      div {
        width: 100%;
        height: 100%;
      }
    }
    
    &__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    &__img-text {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;

      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${props => props.theme.customTheme.colors.lightPrimary};
    }
    
    &__text-wrapper {
      flex-grow: 1;
      overflow-x: hidden;
    }
    
    &__newMessageCount{
      background-color: #078FCD;
      border-radius: 10px;
      padding: 5px 10px;
      color: #fff;
      font-size: 18px;
    }
    
    &__title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      gap: 15px;
    }
    &__description-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      gap: 15px;
    }

    &__title {
      margin: 0;
      font-size: ${props => props.theme.customTheme.sizes.xMiddle};
      line-height: 1.5;
      font-weight: 500;
      color: ${props => props.theme.customTheme.colors.dark};

      // NOTE 1 qator uchun
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__description {
      margin: 0;
      font-size: ${props => props.theme.customTheme.sizes.normal};
      line-height: 1.5;
      font-weight: 400;
      color: ${props => props.theme.customTheme.colors.dark};
      
      &:not(:last-child) {
        margin-bottom: 10px;
      }

      // NOTE 1 qator uchun
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__date {
      font-size: ${props => props.theme.customTheme.sizes.normal};
      line-height: 1.5;
      font-weight: 400;
      color: ${props => props.theme.customTheme.colors.categoryLi};

      flex-shrink: 0;
    }

    &__offerPrice{
      color: #004D70;
      font-size: ${props => props.theme.customTheme.sizes.small};
      font-weight: 500;
      background-color: #E5F4F9;
      border-radius: 8px;
      padding: 5px;

      flex-shrink: 0;
    }

    &__actions {
      display: flex;
      gap: 16px;
    }

    &__action-btn {
      width: 100%;
      justify-content: center;
    }
  }

  @media (max-width: 767.98px) {
    .chat-item {

      &__inner {}

      &__img-wrapper {
        width: 60px;
        height: 60px;
      }

      &__img {}

      &__img-text {}

      &__text-wrapper {}

      &__title-wrapper {}

      &__title {
        font-size: ${props => props.theme.customTheme.sizes.normal};
      }

      &__description {
        font-size: ${props => props.theme.customTheme.sizes.small};
      }

      &__date {
        font-size: ${props => props.theme.customTheme.sizes.xSmall};
      }

      &__actions {}

      &__action-btn {}
    }
  }
`;

export {
  StyledChatItem,
};
